import { useTranslation } from "react-i18next";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { InvoiceAdendaSection } from "@/components/features/adenda/InvoiceAdendaSection";

export interface CompanyAdendaCardProps {
  /** The stored standing adenda; null when none is set. */
  savedAdenda: string | null;
  saving: boolean;
  onSave: (adendaText: string) => Promise<void>;
}

/**
 * The company's standing adenda, as a Settings card of its own.
 *
 * It first shipped inside the invoice-identity dialog — behind the "Editar"
 * button of a card titled "Logo de la empresa" — and users could not find it.
 * The adenda is fiscal text that prints on every CFE, not a branding
 * attribute, so it gets a card at the same level as the logo and the marcas
 * rather than a slot inside one.
 *
 * Sits between the logo card and Marcas deliberately: the next thing after
 * reading it is "can a marca have its own?", which Marcas then answers.
 */
export function CompanyAdendaCard({
  savedAdenda,
  saving,
  onSave,
}: CompanyAdendaCardProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base text-foreground">
          {t("adenda.card.title", "Adenda")}
        </CardTitle>
        <CardDescription>
          {t(
            "adenda.card.description",
            "Texto fijo al pie de todas tus facturas. Cada marca puede tener la suya."
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <InvoiceAdendaSection
          savedAdenda={savedAdenda}
          saving={saving}
          onSave={onSave}
        />
      </CardContent>
    </Card>
  );
}
